import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const anim = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.3,
    ease: 'easeOut' as const
  }
};
export function Professionals() {
  return <section id="nutriólogos" className="bg-primary py-12 lg:py-20 border-t border-text-primary/5" data-id="element-194">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-[72px]" data-id="element-195">
        <div className="text-center mb-8 lg:mb-12" data-id="element-196">
          <h2 className="font-serif text-[28px] md:text-[42px] text-text-primary mb-4" data-id="element-197">
            Nutriólogos certificados y verificables
          </h2>
          <p className="font-sans text-[14px] md:text-[16px] text-text-secondary max-w-[600px] mx-auto" data-id="element-198">
            Cada profesional tiene cédula expedida por la Secretaría de
            Educación Pública. No trabajamos con "coaches" sin formación.
          </p>
        </div>

        <motion.div {...anim} className="max-w-[600px] mx-auto bg-white rounded-3xl p-8 lg:p-10 shadow-warm border border-text-primary/5" data-id="element-199">
          <p className="font-serif text-[20px] text-text-primary mb-6 flex items-center" data-id="element-200">
            <span className="mr-3 text-2xl" data-id="element-201">🎓</span> Todos nuestros nutriólogos
            cumplen:
          </p>

          <ul className="space-y-4 mb-8" data-id="element-202">
            {['Licenciatura en Nutrición', 'Cédula profesional SEP verificable', 'Experiencia en consulta online', 'Seguro de responsabilidad civil'].map((item, i) => <li key={i} className="flex items-center space-x-3" data-id="element-203">
                <Check className="w-5 h-5 text-accent shrink-0" data-id="element-204" />
                <span className="text-[15px] text-text-secondary" data-id="element-205">{item}</span>
              </li>)}
          </ul>

          <div className="bg-primary/30 rounded-xl p-4 text-center" data-id="element-206">
            <p className="text-[13px] text-text-secondary" data-id="element-207">
              Verifica cualquier cédula profesional en:
              <br data-id="element-208" />
              <a href="https://cedulaprofesional.sep.gob.mx" target="_blank" rel="noopener noreferrer" className="font-bold text-accent hover:underline mt-1 inline-block" data-id="element-209">
                cedulaprofesional.sep.gob.mx
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}